import * as v from "valibot";

/**
 * Runs a valibot schema and throws an `Error` with a readable message if the
 * input doesn't match. Replaces the previous manual `typeof` checks that threw
 * an opaque `INVALID_ARGUMENTS` error.
 */
export function parseArgs<
  TSchema extends v.BaseSchema<unknown, unknown, v.BaseIssue<unknown>>,
>(schema: TSchema, input: unknown): v.InferOutput<TSchema> {
  const result = v.safeParse(schema, input);
  if (result.success) {
    return result.output;
  }
  const issue = result.issues[0];
  const path = issue.path?.map((p) => p.key).join(".");
  const location = path ? ` at \`${path}\`` : "";
  throw new Error(`INVALID_ARGUMENTS${location}: ${issue.message}`);
}

export const PlainObject = v.pipe(
  v.unknown(),
  v.check(
    (x) =>
      typeof x === "object" &&
      x !== null &&
      !Array.isArray(x) &&
      !(x instanceof Date),
    "expected a plain object",
  ),
);

export const Record = v.pipe(
  PlainObject,
  v.transform((x) => x as Record<string, unknown>),
);
